import { getSession, getUserVars } from '@nx-frontend/shared/api';
import { sessionFromDto, UserVar } from '@nx-frontend/shared/types';

export interface GetUserVarsPayload {
  userServiceHost: string;
  sessionId: string;
}

export const retrieveUserVars = async (payload: GetUserVarsPayload): Promise<UserVar[]> => {
  const { userServiceHost, sessionId } = payload;
  const { userId } = sessionFromDto(await getSession({ host: userServiceHost, sessionId }));
  return await getUserVars({
    host: userServiceHost,
    userId,
  });
};
